var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.5L7.42301 1.00648C7.1796 0.797839 6.8204 0.797839 6.57699 1.00648L7 1.5ZM1 6.64286L0.576986 6.14934L0.35 6.3439V6.64286H1ZM5.28571 13.5V14.15C5.6447 14.15 5.93571 13.859 5.93571 13.5H5.28571ZM8.71429 13.5H8.06429C8.06429 13.859 8.3553 14.15 8.71429 14.15V13.5ZM13 6.64286H13.65V6.3439L13.423 6.14934L13 6.64286ZM1.85714 14.15H5.28571V12.85H1.85714V14.15ZM13.423 6.14934L7.42301 1.00648L6.57699 1.99352L12.577 7.13637L13.423 6.14934ZM6.57699 1.00648L0.576986 6.14934L1.42301 7.13637L7.42301 1.99352L6.57699 1.00648ZM5.93571 13.5V10.9286H4.63571V13.5H5.93571ZM8.06429 10.9286V13.5H9.36429V10.9286H8.06429ZM8.71429 14.15H12.1429V12.85H8.71429V14.15ZM13.65 12.6429V6.64286H12.35V12.6429H13.65ZM0.35 6.64286V12.6429H1.65V6.64286H0.35ZM7 9.86429C7.58779 9.86429 8.06429 10.3408 8.06429 10.9286H9.36429C9.36429 9.62281 8.30576 8.56429 7 8.56429V9.86429ZM7 8.56429C5.69424 8.56429 4.63571 9.62281 4.63571 10.9286H5.93571C5.93571 10.3408 6.41221 9.86429 7 9.86429V8.56429ZM12.1429 14.15C12.9752 14.15 13.65 13.4752 13.65 12.6429H12.35C12.35 12.7573 12.2573 12.85 12.1429 12.85V14.15ZM1.85714 12.85C1.74274 12.85 1.65 12.7573 1.65 12.6429H0.35C0.35 13.4752 1.02477 14.15 1.85714 14.15V12.85Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceDark);
export default __webpack_public_path__ + "static/media/space-dark.597bc2c192e9093a7e796313935d8470.svg";
export { ForwardRef as ReactComponent };